// packages
import axios from "axios";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// classes
import Diamond from "../../shared/classes/Diamond";
import Jewelry from "../../shared/classes/Jewelry";

// assets
import { PiAlarmLight } from "react-icons/pi";
import "swiper/css";

// utils

export default function SimilarItems({ type, id, path }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/companies/${process.env.REACT_APP_COMPANY_ID}/${type === "diamond" ? "stone" : "jewelry"}-similar/${id}.json`,
      )
      .then((response) => {
        if (type === "diamond") {
          setData(
            response.data.data.map((item) => {
              return new Diamond(item, "/diamonds");
            }),
          );
        } else if (type === "jewelry") {
          setData(
            response.data.data.map((item) => {
              return new Jewelry(item, "/jewelry");
            }),
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching similar items:", error);
      });
  }, []);

  return (
    data &&
    data.length > 0 && (
      <div>
        <h3 className="s-h3 my-4 border-b border-black/5 pb-4 text-center uppercase">
          Similar Items
        </h3>

        {data.length < 4 ? (
          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-4 lg:grid-cols-4">
            {data.map((item, index) => {
              return (
                <NavLink
                  key={index}
                  className="border-hover group relative grid place-content-between border border-black/5 p-4"
                  to={`/${path}/${item.stockNumber}`}
                  target="_blank"
                >
                  {item.onHand && (
                    <div
                      className="absolute left-1 top-1 z-20 flex flex-col items-center bg-t-beige p-1 transition-all duration-300"
                      title="In House"
                    >
                      <PiAlarmLight
                        size={12}
                        className="shrink-0 text-white"
                      />
                    </div>
                  )}
                  <h4 className="s-h4 mx-2 mb-0 text-center text-xs">
                    {location === "bookmark"
                      ? `${item.item.description}${item.item.description_2}`
                      : location === "compare"
                        ? `${item.data.description} ${item.data.description_2}`
                        : item.title}
                  </h4>
                  <div className="flex flex-col items-center overflow-hidden py-2">
                    <div className="flex h-36 items-center justify-center">
                      <img
                        alt={item.images ? item.images.main.alt : item.title}
                        className="max-h-[90%] object-cover transition-all duration-300 group-hover:scale-110"
                        loading="lazy"
                        src={item.images.main.src}
                      />
                    </div>
                    <div className="mt-2 flex items-center justify-center gap-2">
                      <p className="font-body font-bold">{item.price}</p>
                    </div>

                    <h4 className="s-h4 mt-2 text-center text-xs">
                      <span className="pr-1">Stock Number:</span>{" "}
                      {item.stockNumber}
                    </h4>
                  </div>
                </NavLink>
              );
            })}
          </div>
        ) : (
          <Swiper
            modules={[Autoplay, Pagination]}
            autoplay={{
              delay: 2500,
            }}
            loop={true}
            slidesPerView={1}
            spaceBetween={10}
            speed={1500}
            pagination={{
              enabled: true,
              clickable: true,
              dynamicBullets: true,
            }}
            breakpoints={{
              550: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              1200: {
                slidesPerView: 4,
                spaceBetween: 10,
              },
            }}
            style={{
              "--swiper-pagination-color": "#404040",
              "--swiper-pagination-bullet-inactive-color": "#c6a58e",
              "--swiper-pagination-bullet-size": "1rem",
              "--swiper-pagination-bullet-border-radius": "0",
            }}
          >
            {data.map((item, index) => {
              return (
                <SwiperSlide
                  key={index}
                  className="!relative !flex !h-auto !justify-center"
                >
                  <NavLink
                    key={index}
                    className="border-hover group relative mb-12 grid w-full place-content-between border border-black/5 p-4"
                    to={item.route}
                    target="_blank"
                  >
                    {item.onHand && (
                      <div
                        className="absolute left-1 top-1 z-20 flex flex-col items-center bg-t-beige p-1 transition-all duration-300"
                        title="In House"
                      >
                        <PiAlarmLight
                          size={12}
                          className="shrink-0 text-white"
                        />
                      </div>
                    )}
                    <h4 className="s-h4 mx-2 mb-0 text-center text-xs">
                      {location === "bookmark"
                        ? `${item.item.description}${item.item.description_2}`
                        : location === "compare"
                          ? `${item.data.description} ${item.data.description_2}`
                          : item.title}
                    </h4>
                    <div className="flex flex-col justify-between overflow-hidden py-2">
                      <div className="flex h-36 items-center justify-center">
                        <img
                          alt={item.images ? item.images.main.alt : item.title}
                          className="max-h-[90%] transition-all duration-300 group-hover:scale-110"
                          loading="lazy"
                          src={item.images ? item.images.main.src : ImageIcon}
                        />
                      </div>
                      <div className="mt-2 flex items-center justify-center gap-2">
                        <p className="font-body font-bold">{item.price}</p>
                      </div>
                      <h4 className="s-h4 mt-2 text-center text-xs">
                        <span className="pr-1">Stock Number:</span>{" "}
                        {item.stockNumber}
                      </h4>
                    </div>
                  </NavLink>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </div>
    )
  );
}
